export interface ElementStyle {
  label: string;
  badge: string;
  dot: string;
  icon: string;
}

export const ELEMENTS: Record<string, ElementStyle> = {
  pyro: { label: '火', badge: 'border-accent-200 bg-accent-100 text-accent-800', dot: 'bg-accent-500', icon: 'ri-fire-line' },
  hydro: { label: '水', badge: 'border-primary-200 bg-primary-100 text-primary-800', dot: 'bg-primary-500', icon: 'ri-drop-line' },
  anemo: { label: '风', badge: 'border-secondary-200 bg-secondary-100 text-secondary-900', dot: 'bg-secondary-500', icon: 'ri-windy-line' },
  electro: { label: '雷', badge: 'border-primary-300 bg-primary-100 text-primary-900', dot: 'bg-primary-700', icon: 'ri-flashlight-line' },
  cryo: { label: '冰', badge: 'border-primary-200 bg-background-200 text-primary-700', dot: 'bg-primary-300', icon: 'ri-snowy-line' },
  geo: { label: '岩', badge: 'border-accent-200 bg-accent-100 text-accent-900', dot: 'bg-accent-600', icon: 'ri-landscape-line' },
  dendro: { label: '草', badge: 'border-secondary-300 bg-secondary-100 text-secondary-800', dot: 'bg-secondary-700', icon: 'ri-plant-line' },
};

export function getElementStyle(key: string): ElementStyle {
  return ELEMENTS[key] ?? {
    label: key,
    badge: 'border-background-200 bg-background-100 text-foreground-700',
    dot: 'bg-foreground-400',
    icon: 'ri-question-line',
  };
}